import { useContext, useState } from 'react';
import PersonPinCircleIcon from '@mui/icons-material/PersonPinCircle';
import { MediaId } from '../../context/photoConstants';
import { IAppContext, Photo } from '../../types';
import PhotoSectionScreen from '../../screens/PhotoSectionScreen';
import { AppContext } from '../../context/Context';
import {
  refreshGalleryOneScreen,
  removePhotoFromPreview,
} from '../../helpers/photoHelper';
import Modal from '../Modal';
import './index.scss';
import { BRAND } from '../../static/constants/brands/brand';
import { Company } from '../../interfaces/brand';
import IconCamera from '../../assets/imgs/photo-menu/label-camera.svg';

interface props {
  allowMenuSections: boolean;
  currentSection: string;
  links: JSX.Element[];
}

const Gallery = ({
  allowMenuSections,
  currentSection,
  links,
}: props): JSX.Element => {
  const { state, dispatch } = useContext(AppContext) as IAppContext;
  const [previewPhoto, setPreviewPhoto] = useState<Photo | null>(null);

  const removePhoto = async (id: MediaId, url?: string) => {
    await removePhotoFromPreview(id, dispatch, url);
    refreshGalleryOneScreen(dispatch);
    setPreviewPhoto(null);
  };

  const isValidAngleDamagesSeverity = (): boolean => {
    if (state.anglesSelected && state.anglesSelected.length > 0) {
      if (
        !state.notHaveDamages &&
        state.anglesSelected.length !== state.anglesDamageSeverity?.length
      ) {
        return false;
      }
    }

    if (state.anglesDamageSeverity && state.anglesDamageSeverity.length > 0) {
      return state.anglesDamageSeverity?.every((angleDamage) =>
        angleDamage.damageType.every((damage) => !!damage.severity),
      );
    } else {
      if (state.notHaveDamages) {
        return true;
      } else {
        return false;
      }
    }
  };

  return (
    <div id="gallery-container">
      {allowMenuSections ? (
        BRAND == Company.INS ? (
          isValidAngleDamagesSeverity() && (
            <>
              <div
                className="damages-container__title"
                style={{ marginTop: '15px' }}
              >
                <img src={IconCamera} />
                <h3 className="lead2">Fotografías Requeridas</h3>
              </div>
              <p style={{ textAlign: 'left' }}>
                Selecciona un grupo para comenzar a tomar las fotos del vehículo
                según las instrucciones
              </p>
              <div className="photo-section-links">{links}</div>
            </>
          )
        ) : (
          <>
            <h3 className="lead2">Selecciona un grupo</h3>
            <div className="photo-section-links">{links}</div>
          </>
        )
      ) : (
        <>
          <h3 className="lead2">Subir las siguientes fotos solicitadas:</h3>
          <PhotoSectionScreen
            idSection={currentSection}
            onPreviewClick={setPreviewPhoto}
          />
        </>
      )}

      {state.location && (
        <p className="gps-position">
          <PersonPinCircleIcon className="theme-svg-icon gps-icon" />{' '}
          {state.location.lat} / {state.location.lng}
        </p>
      )}

      {previewPhoto?.url && (
        <Modal
          onBackdropClick={() => setPreviewPhoto(null)}
          className="photo-preview-modal"
        >
          <img
            className="preview-photo"
            src={previewPhoto.url}
            alt="Photo preview"
            width={300}
          />
          <div className="action-buttons">
            <button
              className="button button-danger button-block button-left"
              onClick={() => removePhoto(previewPhoto.id, previewPhoto.url)}
            >
              Eliminar
            </button>
            <button
              className="button button-block button-right"
              onClick={() => setPreviewPhoto(null)}
            >
              Cerrar
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Gallery;
